"use strict";

function timeout(time) {
  return new Promise(function (resolve) {
    setTimeout(resolve, time);
  });
}

module.exports = timeout;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/utils/timeout.js
 ** module id = 457
 ** module chunks = 0
 **/